import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import Params from "@kaspernj/api-maker/build/params"
import {Pressable} from "react-native"
import PropTypes from "prop-types"
import {School} from "models"
import Text from "@kaspernj/api-maker/build/utils/text"
import useQueryParams from "on-location-changed/build/use-query-params"

export default memo(shapeComponent(class MyUsersSortLink extends ShapeComponent {
  static propTypes = {
    identifier: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    params: PropTypes.object,
    school: PropTypes.instanceOf(School).isRequired
  }

  setup() {
    const {identifier, params} = this.p
    const sort = params?.sort || "name"
    const sortMode = params?.sortMode

    this.queryParams = useQueryParams()
    this.sort = sort
    this.sortMode = sortMode

    if (sort == identifier) {
      this.sortedByThis = true

      if (sortMode == "desc") {
        this.sortedByThisIcon = "chevron-up"
      } else {
        this.sortedByThisIcon = "chevron-down"
      }
    } else {
      this.sortedByThis = false
      this.sortedByThisIcon = null
    }
  }

  render() {
    const {sort, sortedByThis, sortedByThisIcon} = this.tt
    const {children, identifier, label, ...restProps} = this.props
    let textColor = "#87a2d5"

    if (sortedByThis) {
      textColor = "#2c2c96"
    }

    return (
      <Pressable onPress={this.tt.onPress} style={this.pressableStyle ||= {flexDirection: "row", flex: 0, alignItems: "center"}} {...restProps}>
        <Text style={this.cache("textStyle", {color: textColor, paddingRight: 6}, [textColor])}>
          {label}
        </Text>
        {sort == identifier &&
          <Icon
            name={sortedByThisIcon}
            size={16}
            version="FontAwesome6"
          />
        }
      </Pressable>
    )
  }

  onPress = () => {
    const {queryParams, sortedByThis, sortMode} = this.tt
    const {identifier, school} = this.p
    const newQueryParams = queryParams.my_users_params ? JSON.parse(queryParams.my_users_params) : {}

    if (!(school.id() in newQueryParams)) {
      newQueryParams[school.id()] = {}
    }

    const schoolParams = newQueryParams[school.id()]

    schoolParams.sort = identifier

    if (sortedByThis && sortMode != "desc") {
      schoolParams.sortMode = "desc"
    } else {
      delete schoolParams.sortMode
    }

    const newQueryParamsString = JSON.stringify(newQueryParams)

    Params.changeParams({my_users_params: newQueryParamsString})
  }
}))
